

export const AuctionPage = () => {
    return (
        <div className="">
            <h2>Auction Page</h2>
        </div>
    )
}

export default AuctionPage